import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import IndustryCompare from './industry-compare/index';
import TimeTrend from './time-trend/index';
import DistributionRate from './distribution-rate/index';
import StuffTrend from './stuff-trend/index';
import Title from '../component/title';
import Indicators from '../component/indicators';
import moSkin from '@store/skin';
import moUser from '@store/user';
import moStore, { toggleValue } from '@store/index';
import moEffect from '../store/index';
import moSettle, { settleInit } from './store/index';
import moSettingCompare, {
  settleCompareInit,
} from './industry-compare/store/index';
import moTimeTrend, {
  timeTrendInit,
} from './time-trend/store/index';
import moStaffTrend, {
  staffTrendInit,
} from './stuff-trend/store/index';
import moDistribution, {
  distributionInit,
} from './distribution-rate/store/index';

interface IProps {}
interface IState {}

const StuffSettle = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const [stafOpen, setStaffOpen] = useState(false);
  const staffingList = [
    '人员规模：在所选行业、年度下，所有上市公司的员工数。',
    '变化率：均为与上一年相比的同比变化率。',
  ];

  useEffect(() => {
    const show = localStorage.getItem('showIndicator');
    if (show === 'false') setStaffOpen(false);
    else setStaffOpen(true);

    return () => {};
  }, []);

  const onOpenStaf = () => {
    setStaffOpen(true);
  };

  const onCloseStaf = () => {
    setStaffOpen(false);
  };

  return (
    <section className="stuff-settle_10">
      <Title title="人员配置" subtitle="人员配置" onIndi={onOpenStaf} />
      {stafOpen && <Indicators onClose={onCloseStaf}
        list={staffingList} />}
      <IndustryCompare />
      <TimeTrend />
      <DistributionRate />
      <StuffTrend />
    </section>
  );
};

export default observer(StuffSettle);
